import { useTranslation } from 'next-i18next'
import { MessageContainer } from '@fe/common/components/loggedOutStyles'
import { MessageText } from '@fe/common/components/typography/MessageText'
import { useDelayedNavigate } from '@fe/common/hooks/useDelayedNavigate'
import Check from '@fe/common/src/icons/check-circle.svg'

export const SuccessStep: React.FC = () => {
  const { t } = useTranslation('no-auth')

  useDelayedNavigate()

  return (
    <MessageContainer height="19rem">
      <Check />

      <MessageText>{t('reset-email-resent')}</MessageText>
    </MessageContainer>
  )
}
